import type {
  ErrorMonitoringService,
  ErrorMonitoringServiceInterface,
  ExclusiveEventHintOrCaptureContext,
} from './ErrorMonitoring';

const noop = {
  setTag: () => null,
  captureException: () => null,
} as unknown as ErrorMonitoringServiceInterface;

export class SentryMonitoringClientService implements ErrorMonitoringService {
  private sentryInstance?: ErrorMonitoringServiceInterface;

  async addCustomTag(key: string, value: string) {
    const instance = await this.getInstance();
    instance.setTag(key, value);
  }

  async captureError(error: unknown, hint?: ExclusiveEventHintOrCaptureContext) {
    const instance = await this.getInstance();
    instance.captureException(error, hint);
  }

  async identify(id: string) {
    await this.addCustomTag('device_id', id);
  }

  private async getInstance(): Promise<ErrorMonitoringServiceInterface> {
    if (!this.sentryInstance) {
      try {
        this.sentryInstance = await import('@sentry/nextjs');
      } catch {
        this.sentryInstance = noop;
      }
    }

    return this.sentryInstance;
  }
}
